import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SideContainers = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  padding-bottom: ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[7]}px;
`;

export const ContainerBannerInformativo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5;
  min-width: 0;
`;

export const ContainerBannerImagem = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    background-color: ${({ theme }) => theme.colors.neutral.neutral_alpha[3]};
  }
`;

export const GradienteFundo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 110px;
  z-index: 1;
`;

export const GradienteLateralDireita = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100px;
  z-index: 1;
`;

export const ContainerConteudoBannerInformativo = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: ${({ theme }) => theme.spacing[5]}px;
  z-index: 2;

  padding: 0 ${({ theme }) => theme.spacing[7]}px;
`;

export const ContainerCheckoutEInformacoes = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  min-width: 0;

  ${({ theme }) => {
    return css`
      padding-top: ${theme.spacing[5]}px;
      padding-right: ${theme.spacing[6]}px;
      gap: ${theme.spacing[4]}px;
    `;
  }};
`;
